import { CardCvcElement, CardExpiryElement, CardNumberElement, ElementsConsumer } from '@stripe/react-stripe-js';
import * as React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Stripe, StripeElements } from '@stripe/stripe-js';
import { Button, Small, Center, SpaceBetween, Column, EmptyLine, inputStyle, DateCvcBox } from './styled';
import { isSmallDevice, isSafari, resolveTextWithLinks, timeBeforeRenewalIsPassed } from '../helpers/util';
import { LoaderButton } from '.';
import { appActions } from '../store/ducks/app';
import { Status } from '../helpers/product';

interface State {
  agreementChecked: boolean;
}
interface OwnProps {
  stripe?: Stripe | null;
  elements?: StripeElements | null;
  intl?: any;
  update?: boolean;
}

const mapStateToProps = (state: any) => ({
  paymentIsBusy: state.appData.payment.isBusy,
  validationError: state.appData.payment.validationError,
  cardNameError: state.appData.payment.cardNameError,
  agreementError: state.appData.payment.agreementError,
  general: state.appData.general,
  language: state.appData.language,
  subscription: state.appData.subscription,
});
type StateProps = ReturnType<typeof mapStateToProps>;

interface DispatchProps {
  startPayment: (cardName: string, stripe: any, elements: any, agreement: boolean) => void;
  updatePaymentMethod: (cardName: string, stripe: any, elements: any) => void;
  switchError: (errorName: string, error: boolean) => void;
}

type Props = OwnProps & StateProps & DispatchProps;

class InputCardDetailsForm extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      agreementChecked: false,
    };
  }

  switchAgreement = () => {
    this.setState({ agreementChecked: !this.state.agreementChecked });
    this.props.switchError('agreementError', false);
  };

  handlePayment = (event: any) => {
    // We don't want to let default form submission happen here, which would refresh the page.
    event.persist();
    event.preventDefault();

    if (this.props.update) {
      if (this.props.subscription?.status === Status.ACTIVE && timeBeforeRenewalIsPassed(this.props.subscription?.nextPaymentTimestamp)) {
        this.props.startPayment(event.target.cardname.value, this.props.stripe, this.props.elements, true);
      } else {
        this.props.updatePaymentMethod(event.target.cardname.value, this.props.stripe, this.props.elements);
      }
    } else {
      const agreement = !((!this.props.update && !this.state.agreementChecked));
      this.props.startPayment(event.target.cardname.value, this.props.stripe, this.props.elements, agreement);
    }
  }

  checkInput = (event: any) => {
    this.props.switchError('cardNameError', !event.target.value);
  }

  render() {
    return (
      <form onSubmit={this.handlePayment}>
        { isSmallDevice() && isSafari() && <><EmptyLine /><EmptyLine /></> }
        <Column>
          <label htmlFor="cardname"><FormattedMessage id="name_on_the_card" /></label>
          <input className={this.props.cardNameError ? 'cardNameInvalid' : 'cardName'} type="text" id="cardname" name="cardname"
            minLength={1} maxLength={100} onKeyUp={this.checkInput} disabled={this.props.paymentIsBusy} />
        </Column>
        <Column>
          <label htmlFor="cardnumber"><FormattedMessage id="card_number" /></label>
          <CardNumberElement options={inputStyle} />
        </Column>
        <SpaceBetween>
          <DateCvcBox>
            <label htmlFor="exp-date"><FormattedMessage id="expiry_date" /></label>
            <CardExpiryElement options={inputStyle} />
          </DateCvcBox>
          <DateCvcBox>
            <label htmlFor="cvc"><FormattedMessage id="security_code" /></label>
            <CardCvcElement options={inputStyle} />
          </DateCvcBox>
        </SpaceBetween>
        <br />
        {
          this.props.validationError && (
            <Column>
              <Small red={true}>
                { this.props.intl.formatMessage({ id: this.props.validationError, defaultMessage: 'Something went wrong, please refresh.' }) }
              </Small>
            </Column>
          )
        }
        <Column>
          <Small><FormattedMessage id="payment_provider" /></Small>
        </Column>
        {
          !this.props.update && (
            <Column>
              <div className="form-group">
                <div className="form-group--checkbox">
                  <span onClick={this.switchAgreement} className={this.state.agreementChecked ? 'checkbox checkbox--active' : 'checkbox'} />
                  <Small red={this.props.agreementError}>{
                    resolveTextWithLinks(
                      this.props.intl.formatMessage({ id: 'agreement' }),
                      [`${this.props.general.config.termsOfUseLink}${this.props.language}/`,
                        `${this.props.general.config.privacyPolicyLink}${this.props.language}/`]
                    )
                  }
                  </Small>
                </div>
              </div>
            </Column>
          )
        }
        <Column>
          <Center>
            <Button type="submit" disabled={!this.props.stripe || this.props.paymentIsBusy}>
              {
                this.props.paymentIsBusy ? <LoaderButton /> :
                  <FormattedMessage id={this.props.update ? 'update_card_details' : 'confirm_subscription'} />
              }
            </Button>
          </Center>
        </Column>
      </form>
    );
  }
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, appActions)(injectIntl(injectedCheckoutForm));

export function injectedCheckoutForm(props: Props) {
  return (
    <ElementsConsumer>
      { ({ stripe, elements }) => <InputCardDetailsForm {...props} stripe={stripe} elements={elements} /> }
    </ElementsConsumer>
  );
}
